// module.exports = file => () => import('@/views/' + file + '.vue')
// () => import(/* webpackChunkName: "about" */ '../views/About.vue')
// module.exports = file => resolve=>{
//     require.ensure(['@/views/' + file + '.vue'],()=>{
//       resolve(require(['@/views/' + file + '.vue']))
//     })
//   }

module.exports = file => require('@/views/' + file + '.vue').default
  // module.exports = file=>() => import( /* webpackChunkName: "[request]" */ '../view/${file}.vue')